module.exports = __webpack_public_path__ + "static/media/call_with_alexandra_zoe_worden.21681cfd.jpg";